import './Pill.scss'

const Pill = (props: any) => {
    return <span className="pill-wrapper">{props.children}</span>
}

export default Pill;